import {
  FormControlLabel,
  FormControlLabelProps,
  FormHelperText,
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps,
} from '@mui/material';
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';

export interface SwitchProps<TFieldValues extends FieldValues = FieldValues> {
  name: FieldPath<TFieldValues>;
  control: Control<TFieldValues>;
  label?: string;
  disabled?: boolean;
  helperText?: string;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
}

export function Switch<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  disabled,
  helperText,
  labelPlacement = 'end',
  ...switchProps
}: SwitchProps<TFieldValues> & Omit<MuiSwitchProps, 'name' | 'control' | 'checked' | 'onChange'>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <>
          <FormControlLabel
            control={
              <MuiSwitch
                {...switchProps}
                checked={field.value || false}
                onChange={(event) => field.onChange(event.target.checked)}
                disabled={disabled}
              />
            }
            label={label}
            labelPlacement={labelPlacement}
          />
          {fieldState.error?.message && (
            <FormHelperText error>{fieldState.error.message}</FormHelperText>
          )}
          {helperText && !fieldState.error && (
            <FormHelperText>{helperText}</FormHelperText>
          )}
        </>
      )}
    />
  );
}